const getCustomerDetails = (details) => {
  if (!details) {
    return void 0;
  }
  const { email, phone } = details;
  return {
    email,
    dateOfBirth: details.dateOfBirth ?? "",
    phone: phone ?? ""
  };
};
export {
  getCustomerDetails
};
//# sourceMappingURL=get-customer-details.js.map
